import { useState, useEffect } from 'react';
import { Role } from '../../types/permissions/role';
import { roleService } from '../../services';
import toast from 'react-hot-toast';

export const useRoles = () => {
  const [roles, setRoles] = useState<Role[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadRoles = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await roleService.getRoles();
      if (response.roles) {
        setRoles(response.roles);
      }
    } catch (err) {
      console.error('Error cargando roles:', err);
      setError('Error al cargar los roles');
      toast.error('Error al cargar los roles');
    } finally {
      setLoading(false);
    }
  };

  const createRole = async (name: string, description: string) => {
    try {
      const response = await roleService.createRole({ name, description });
      if (response.success) {
        toast.success(response.message);
        await loadRoles(); // Recargar roles
        return true;
      }
      return false;
    } catch (err) {
      console.error('Error creando rol:', err);
      toast.error('Error al crear el rol');
      return false;
    }
  };

  const deleteRole = async (roleId: number) => {
    try {
      const response = await roleService.deleteRole(roleId);
      if (response.success) {
        toast.success(response.message);
        await loadRoles(); // Recargar roles
        return true;
      }
      return false;
    } catch (err) {
      console.error('Error eliminando rol:', err);
      toast.error('Error al eliminar el rol');
      return false;
    }
  };

  useEffect(() => {
    loadRoles();
  }, []);

  return {
    roles,
    loading,
    error,
    loadRoles,
    createRole,
    deleteRole
  };
};
